module.exports = __webpack_public_path__ + "img/consultation.74f62c07.png";